import { useEffect, useRef } from 'react';
import { useDownloadExcel } from 'react-export-table-to-excel';
import { useDispatch, useSelector } from 'react-redux';
import { clearMedicalCommission } from '../../../../appRedux/actions/Reports';
import { formatPrice } from '../../../../util/formatPrice';
import { formatFileName } from '../../../../util/strings';
import { getFullName } from '../../../../util';
import { ExportButton } from '../../../uiComponents/ExportButton';
import { ReportTableHeader } from '../../../uiComponents/ReportTableHeader';
import { medicalComissionsReportConst } from '../../../../constants/MedicalCommissionsByBranch';
import { MedicalCommissionsByBranchReportFilter } from '../../ReportFilter/MedicalCommissionByBranchReportFilter';
import { DataNotFound } from '../DataNotFound';
import { clearMedicalCommissionsByBranchReport } from '../../../../appRedux/actions/Reports';

export const MedicalCommissionsByBranchReport = () => {
  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const { fullname, role } = useSelector((state) => state.userAuth);
  const { medicalComissionByBranch } = useSelector((state) => state.reports);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: formatFileName(medicalComissionsReportConst.title),
    sheet: medicalComissionsReportConst.title,
  });
  const hasData = !!Object.keys(medicalComissionByBranch).length;

  useEffect(() => {
    dispatch(clearMedicalCommissionsByBranchReport());
  }, [dispatch]);

  const header = medicalComissionsReportConst.header;
  let subTotal = 0;
  let isrTotal = 0;
  let totalNeto = 0;

  useEffect(() => {
    dispatch(clearMedicalCommission());
  }, [dispatch]);

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <ExportButton onDownload={onDownload} disabled={!hasData} />
        <MedicalCommissionsByBranchReportFilter />
      </div>

      <div ref={tableRef}>
        {hasData ? (
          <table style={{ margin: '0 auto' }}>
            <ReportTableHeader
              user={fullname}
              role={role}
              title={medicalComissionsReportConst.title}
              col1={6}
              col2={0}
              col3={10}
            />
            <tbody>
              <tr>
                {header?.map((item, key) => (
                  <th
                    key={key}
                    colSpan={2}
                    style={{ border: '1px solid black', padding: '15px' }}
                  >
                    {item}
                  </th>
                ))}
              </tr>

              {medicalComissionByBranch?.map((row, key) => {
                subTotal += Number(row.subtotal);
                isrTotal += Number(row.isr);
                totalNeto += Number(row.commission);

                return (
                  <tr key={key}>
                    <td
                      colSpan={2}
                      style={{
                        border: '1px solid black',
                        textAlign: 'center',
                        padding: '15px',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {getFullName({ name: row?.name, lastName: row?.lastName, motherLastName: row?.motherLastName })}
                    </td>
                    <td
                      colSpan={2}
                      style={{
                        border: '1px solid black',
                        textAlign: 'center',
                        padding: '15px',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {row.branch}
                    </td>
                    <td
                      colSpan={2}
                      style={{
                        border: '1px solid black',
                        textAlign: 'center',
                        padding: '15px',
                      }}
                    >
                      {formatPrice(row.subtotal)}
                    </td>
                    <td
                      colSpan={2}
                      style={{
                        border: '1px solid black',
                        textAlign: 'center',
                        padding: '15px',
                      }}
                    >
                      {formatPrice(row.isr)}
                    </td>
                    <td
                      colSpan={2}
                      style={{
                        border: '1px solid black',
                        textAlign: 'center',
                        padding: '15px',
                      }}
                    >
                      {formatPrice(row.commission)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <td
                  colSpan={4}
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                    backgroundColor: '#e6e9eb',
                    padding: '15px',
                  }}
                >
                  <h4>SUBTOTAL GENERAL</h4>
                </td>
                <td
                  colSpan={6}
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                    backgroundColor: '#e6e9eb',
                    padding: '15px',
                  }}
                >
                  {formatPrice(subTotal)}
                </td>
              </tr>
              <tr>
                <td
                  colSpan={4}
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                    backgroundColor: '#e6e9eb',
                    padding: '15px',
                  }}
                >
                  <h4>TOTAL DE ISR</h4>
                </td>
                <td
                  colSpan={6}
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                    backgroundColor: '#e6e9eb',
                    padding: '15px',
                  }}
                >
                  {formatPrice(isrTotal)}
                </td>
              </tr>
              <tr>
                <td
                  colSpan={4}
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                    backgroundColor: '#e6e9eb',
                    padding: '15px',
                  }}
                >
                  <h4>TOTAL NETO</h4>
                </td>
                <td
                  colSpan={6}
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                    backgroundColor: '#e6e9eb',
                    padding: '15px',
                  }}
                >
                  {formatPrice(totalNeto)}
                </td>
              </tr>
            </tfoot>
          </table>
        ) : (
          <DataNotFound />
        )}
      </div>
    </div>
  );
};
